// Import controller interfaces
import {
    IPolicyNoteController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    PolicyNote,
    PolicyNoteDocument,
    PolicyNoteDocumentWithData,
    PolicyNoteEmail,
    PolicyNoteRecord,
    PossibleCorrespondenceReason,
    PossibleCorrespondenceRecvdOrSent,
    PossibleCorrespondenceSubject,
    PossibleCorrespondenceType,
    PossibleCorrespondenceWho,
} from '@app/models/api';
// Import enumerations
import {
    UnderwriterActionType
} from '@app/enumerations';

export default class MockPolicyNoteController implements IPolicyNoteController {

    public constructor() {

    }

    public async getPolicyNotes(policyId: number): Promise<PolicyNoteRecord[]> {
        return new Promise((resolve, reject) => {
            let policyNote1: PolicyNoteRecord = new PolicyNoteRecord();
            policyNote1.id = 1;
            policyNote1.adminOnly = true;
            policyNote1.complaintInitiated = false;
            policyNote1.correspondenceEmailAddress = 'correspondence1@test.com';
            policyNote1.correspondenceName = 'Test Testerson';
            policyNote1.correspondencePhone1 = '9999999999';
            policyNote1.correspondenceReasons = [
                'Rewrite',
            ];
            policyNote1.correspondenceRecvdOrSent = 'Received';
            policyNote1.correspondenceSubject = 'Policy';
            policyNote1.correspondenceType = 'Email';
            policyNote1.correspondenceWho = 'Adjuster';
            policyNote1.dateSubmit = new Date();
            policyNote1.flagDate = new Date();
            policyNote1.isFlag = true;
            policyNote1.isMailed = true;
            policyNote1.note = 'This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.';
            policyNote1.submittedBy = 'Tester';
            policyNote1.underwriterAction = UnderwriterActionType.NONE;

            let policyNote2: PolicyNoteRecord = new PolicyNoteRecord();
            policyNote2.id = 2;
            policyNote2.adminOnly = false;
            policyNote2.correspondenceRecvdOrSent = 'Entered/No correspondence';
            policyNote2.dateSubmit = new Date();
            policyNote2.isFlag = false;
            policyNote2.isMailed = true;
            policyNote2.note = 'This is a test note 2.';
            policyNote2.submittedBy = 'Tester';
            policyNote2.underwriterAction = UnderwriterActionType.NONE;

            let policyNote3: PolicyNoteRecord = new PolicyNoteRecord();
            policyNote3.id = 3;
            policyNote3.adminOnly = true;
            policyNote3.correspondenceRecvdOrSent = 'Entered/No correspondence';
            policyNote3.dateSubmit = new Date();
            policyNote3.flagDate = new Date();
            policyNote3.isFlag = false;
            policyNote3.isMailed = true;
            policyNote3.note = 'This is a test note 3.';
            policyNote3.submittedBy = 'Tester';
            policyNote3.underwriterAction = UnderwriterActionType.NONE;
            policyNote3.docName = 'TestDoc.pdf';


            setTimeout(() => {
                resolve([
                    policyNote1,
                    policyNote2,
                    policyNote3,
                ]);
            }, 1000);
        });
    }

    public async savePolicyNote(policyId: number,
        note: string,
        document: PolicyNoteDocumentWithData): Promise<PolicyNoteRecord> {

        return new Promise((resolve, reject) => {

            let policyNote: PolicyNoteRecord = new PolicyNoteRecord();
            policyNote.id = parseInt((Math.random() * 1000000).toString());
            policyNote.note = note;
            policyNote.docName = document.docName;
            policyNote.dateSubmit = new Date();
            policyNote.submittedBy = 'Tester';

            setTimeout(() => {
                resolve(policyNote);
            }, 1000);
        });
    }

    public async savePolicyNoteAdmin(policyId: number,
        policyNote: PolicyNote,
        document: PolicyNoteDocumentWithData): Promise<PolicyNoteRecord> {

        return new Promise((resolve, reject) => {

            let policyNoteRecord: PolicyNoteRecord = new PolicyNoteRecord();
            policyNoteRecord.id = parseInt((Math.random() * 1000000).toString());
            policyNoteRecord.adminOnly = policyNote.adminOnly;
            policyNoteRecord.complaintInitiated = policyNote.complaintInitiated;
            policyNoteRecord.correspondenceEmailAddress = policyNote.correspondenceEmailAddress;
            policyNoteRecord.correspondenceName = policyNote.correspondenceName;
            policyNoteRecord.correspondencePhone1 = policyNote.correspondencePhone1;
            policyNoteRecord.correspondencePhone2 = policyNote.correspondencePhone2;
            policyNoteRecord.correspondenceReasons = policyNote.correspondenceReasons;
            policyNoteRecord.correspondenceRecvdOrSent = policyNote.correspondenceRecvdOrSent;
            policyNoteRecord.correspondenceSubject = policyNote.correspondenceSubject;
            policyNoteRecord.correspondenceType = policyNote.correspondenceType;
            policyNoteRecord.correspondenceWho = policyNote.correspondenceWho;
            policyNoteRecord.dateSubmit = new Date();
            policyNoteRecord.flagDate = policyNote.flagDate
            policyNoteRecord.isFlag = policyNote.isFlag;
            policyNoteRecord.note = policyNote.note;
            policyNoteRecord.dateSubmit = new Date();
            policyNoteRecord.submittedBy = 'Tester';
            policyNoteRecord.isMailed = false;
            policyNoteRecord.docName = document.docName;
            policyNoteRecord.underwriterAction = UnderwriterActionType.NONE;

            setTimeout(() => {
                resolve(policyNoteRecord);
            }, 1000);
        });
    }

    public async saveNoteToPolicyNote(policyNoteId: number,
        note: string): Promise<PolicyNoteRecord> {

        return new Promise((resolve, reject) => {
            let policyNoteRecord: PolicyNoteRecord = new PolicyNoteRecord();
            policyNoteRecord.id = policyNoteId;
            policyNoteRecord.note = note;

            setTimeout(() => {
                resolve(policyNoteRecord);
            }, 1000);
        });
    }

    public async changeFlagDate(policyNoteId: number,
        flagDate: Date,
        note: string): Promise<PolicyNoteRecord> {

        return new Promise((resolve, reject) => {
            let policyNoteRecord: PolicyNoteRecord = new PolicyNoteRecord();
            policyNoteRecord.id = policyNoteId;
            policyNoteRecord.flagDate = flagDate;
            policyNoteRecord.note = note;

            setTimeout(() => {
                resolve(policyNoteRecord);
            }, 1000);
        });
    }

    public async markPolicyNoteAsComplete(policyNoteId: number,
        note: string): Promise<PolicyNoteRecord> {

        return new Promise((resolve, reject) => {
            let policyNoteRecord: PolicyNoteRecord = new PolicyNoteRecord();
            policyNoteRecord.id = policyNoteId;
            policyNoteRecord.isFlag = false;
            policyNoteRecord.note = note;

            setTimeout(() => {
                resolve(policyNoteRecord);
            }, 1000);
        });
    }

    public async archivePolicyNote(policyNoteId: number): Promise<void> {
        return new Promise((resolve, reject) => {

            setTimeout(() => {
                resolve();
            }, 1000);
        });
    }

    public async getPolicyNoteEmails(policyId: number): Promise<PolicyNoteEmail[]> {
        return new Promise((resolve, reject) => {
            let policyNoteEmail1: PolicyNoteEmail = new PolicyNoteEmail();
            policyNoteEmail1.id = 1;
            policyNoteEmail1.adminOnly = true;
            policyNoteEmail1.complaintInitiated = false;
            policyNoteEmail1.correspondenceEmailAddress = 'correspondence1@test.com';
            policyNoteEmail1.correspondenceName = 'Test Testerson';
            policyNoteEmail1.correspondencePhone1 = '9999999999';
            policyNoteEmail1.correspondenceReason = 'Rewrite';
            policyNoteEmail1.correspondenceRecvdOrSent = 'Received';
            policyNoteEmail1.correspondenceSubject = 'Policy';
            policyNoteEmail1.correspondenceType = 'Email';
            policyNoteEmail1.correspondenceWho = 'Adjuster';
            policyNoteEmail1.dateSubmit = new Date();
            policyNoteEmail1.dateUploaded = new Date();
            policyNoteEmail1.flagDate = new Date();
            policyNoteEmail1.username = 'Tester';
            policyNoteEmail1.note = 'This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.  This is a test note 1.';
            policyNoteEmail1.recordType = 'Quote',

            setTimeout(() => {
                resolve([
                    policyNoteEmail1,
                ]);
            }, 1000);
        });
    }

    public async getPossibleCorrespondenceRecvdOrSentOptions(): Promise<PossibleCorrespondenceRecvdOrSent[]> {
        return new Promise((resolve, reject) => {
            let receivedPossibleCorrespondenceRecvdOrSent: PossibleCorrespondenceRecvdOrSent = new PossibleCorrespondenceRecvdOrSent();
            receivedPossibleCorrespondenceRecvdOrSent.code = 'Received';
            receivedPossibleCorrespondenceRecvdOrSent.displayName = 'Received';
            receivedPossibleCorrespondenceRecvdOrSent.isCorrespondenceInfoRequired = true;

            let outgoingPossibleCorrespondenceRecvdOrSent: PossibleCorrespondenceRecvdOrSent = new PossibleCorrespondenceRecvdOrSent();
            outgoingPossibleCorrespondenceRecvdOrSent.code = 'Outgoing';
            outgoingPossibleCorrespondenceRecvdOrSent.displayName = 'Outgoing';
            outgoingPossibleCorrespondenceRecvdOrSent.isCorrespondenceInfoRequired = true;

            let noPossibleCorrespondenceRecvdOrSent: PossibleCorrespondenceRecvdOrSent = new PossibleCorrespondenceRecvdOrSent();
            noPossibleCorrespondenceRecvdOrSent.code = 'Entered/No correspondence';
            noPossibleCorrespondenceRecvdOrSent.displayName = 'Entered/No correspondence';
            noPossibleCorrespondenceRecvdOrSent.isCorrespondenceInfoRequired = false;

            setTimeout(() => {
                resolve([
                    receivedPossibleCorrespondenceRecvdOrSent,
                    outgoingPossibleCorrespondenceRecvdOrSent,
                    noPossibleCorrespondenceRecvdOrSent,
                ]);
            }, 1000);
        });
    }

    public async getPossibleCorrespondenceTypeOptions(): Promise<PossibleCorrespondenceType[]> {
        return new Promise((resolve, reject) => {
            let phoneCallPossibleCorrespondenceType: PossibleCorrespondenceType = new PossibleCorrespondenceType();
            phoneCallPossibleCorrespondenceType.code = 'Phone Call';
            phoneCallPossibleCorrespondenceType.displayName = 'Phone Call';

            let emailPossibleCorrespondenceType: PossibleCorrespondenceType = new PossibleCorrespondenceType();
            emailPossibleCorrespondenceType.code = 'Email';
            emailPossibleCorrespondenceType.displayName = 'Email';

            let faxPossibleCorrespondenceType: PossibleCorrespondenceType = new PossibleCorrespondenceType();
            faxPossibleCorrespondenceType.code = 'Fax';
            faxPossibleCorrespondenceType.displayName = 'Fax';

            let inPersonPossibleCorrespondenceType: PossibleCorrespondenceType = new PossibleCorrespondenceType();
            inPersonPossibleCorrespondenceType.code = 'In Person';
            inPersonPossibleCorrespondenceType.displayName = 'In Person';

            let followUpPossibleCorrespondenceType: PossibleCorrespondenceType = new PossibleCorrespondenceType();
            followUpPossibleCorrespondenceType.code = 'Follow up';
            followUpPossibleCorrespondenceType.displayName = 'Follow up';

            setTimeout(() => {
                resolve([
                    phoneCallPossibleCorrespondenceType,
                    emailPossibleCorrespondenceType,
                    faxPossibleCorrespondenceType,
                    inPersonPossibleCorrespondenceType,
                    followUpPossibleCorrespondenceType,
                ]);
            }, 1000);
        });
    }

    public async getPossibleCorrespondenceWhoOptions(): Promise<PossibleCorrespondenceWho[]> {
        return new Promise((resolve, reject) => {
            let producerPossibleCorrespondenceWho: PossibleCorrespondenceWho = new PossibleCorrespondenceWho();
            producerPossibleCorrespondenceWho.code = 'Producer';
            producerPossibleCorrespondenceWho.displayName = 'Producer';

            let adjusterPossibleCorrespondenceWho: PossibleCorrespondenceWho = new PossibleCorrespondenceWho();
            adjusterPossibleCorrespondenceWho.code = 'Adjuster';
            adjusterPossibleCorrespondenceWho.displayName = 'Adjuster';

            let insuredPossibleCorrespondenceWho: PossibleCorrespondenceWho = new PossibleCorrespondenceWho();
            insuredPossibleCorrespondenceWho.code = 'Insured';
            insuredPossibleCorrespondenceWho.displayName = 'Insured';

            let underwriterPossibleCorrespondenceWho: PossibleCorrespondenceWho = new PossibleCorrespondenceWho();
            underwriterPossibleCorrespondenceWho.code = 'Underwriter';
            underwriterPossibleCorrespondenceWho.displayName = 'Underwriter';

            let bankPossibleCorrespondenceWho: PossibleCorrespondenceWho = new PossibleCorrespondenceWho();
            bankPossibleCorrespondenceWho.code = 'Bank';
            bankPossibleCorrespondenceWho.displayName = 'Bank';

            let municipalPossibleCorrespondenceWho: PossibleCorrespondenceWho = new PossibleCorrespondenceWho();
            municipalPossibleCorrespondenceWho.code = 'Municipal';
            municipalPossibleCorrespondenceWho.displayName = 'Municipal';

            setTimeout(() => {
                resolve([
                    producerPossibleCorrespondenceWho,
                    adjusterPossibleCorrespondenceWho,
                    insuredPossibleCorrespondenceWho,
                    underwriterPossibleCorrespondenceWho,
                    bankPossibleCorrespondenceWho,
                    municipalPossibleCorrespondenceWho,
                ]);
            }, 1000);
        });
    }

    public async getPossibleCorrespondenceSubjectOptions(): Promise<PossibleCorrespondenceSubject[]> {
        return new Promise((resolve, reject) => {

            let formsAndDocumentsPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            formsAndDocumentsPossibleCorrespondenceReason.code = 'Forms and Documents';
            formsAndDocumentsPossibleCorrespondenceReason.displayName = 'Forms and Documents';

            let statusPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            statusPossibleCorrespondenceReason.code = 'Status';
            statusPossibleCorrespondenceReason.displayName = 'Status';

            let changeRequestPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            changeRequestPossibleCorrespondenceReason.code = 'Change Request';
            changeRequestPossibleCorrespondenceReason.displayName = 'Change Request';

            let disputeOfPrivateFloodInsuranceRequestPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            disputeOfPrivateFloodInsuranceRequestPossibleCorrespondenceReason.code = 'Dispute of Private Flood Insurance';
            disputeOfPrivateFloodInsuranceRequestPossibleCorrespondenceReason.displayName = 'Dispute of Private Flood Insurance';

            let requestToInitiateNewClaimPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            requestToInitiateNewClaimPossibleCorrespondenceReason.code = 'Request to Initiate New Claim';
            requestToInitiateNewClaimPossibleCorrespondenceReason.displayName = 'Request to Initiate New Claim';

            let websiteNavigationPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            websiteNavigationPossibleCorrespondenceReason.code = 'Website Navigation';
            websiteNavigationPossibleCorrespondenceReason.displayName = 'Website Navigation';

            let underwritingInquiryPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            underwritingInquiryPossibleCorrespondenceReason.code = 'Underwriting Inquiry';
            underwritingInquiryPossibleCorrespondenceReason.displayName = 'Underwriting Inquiry';

            let cancellationInquiryPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            cancellationInquiryPossibleCorrespondenceReason.code = 'Cancellation Inquiry';
            cancellationInquiryPossibleCorrespondenceReason.displayName = 'Cancellation Inquiry';

            let applicationInquiryPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            applicationInquiryPossibleCorrespondenceReason.code = 'Application Inquiry';
            applicationInquiryPossibleCorrespondenceReason.displayName = 'Application Inquiry';

            let rushRequestPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            rushRequestPossibleCorrespondenceReason.code = 'Rush Request';
            rushRequestPossibleCorrespondenceReason.displayName = 'Rush Request';

            let rejectedPaymentPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            rejectedPaymentPossibleCorrespondenceReason.code = 'Rejected Payment';
            rejectedPaymentPossibleCorrespondenceReason.displayName = 'Rejected Payment';

            let rewritePaymentPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            rewritePaymentPossibleCorrespondenceReason.code = 'Rewrite';
            rewritePaymentPossibleCorrespondenceReason.displayName = 'Rewrite';

            let nonRenewalPaymentPossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            nonRenewalPaymentPossibleCorrespondenceReason.code = 'Non-Renewal';
            nonRenewalPaymentPossibleCorrespondenceReason.displayName = 'Non-Renewal';

            let paymentHandlingAcceptancePossibleCorrespondenceReason: PossibleCorrespondenceReason = new PossibleCorrespondenceReason();
            paymentHandlingAcceptancePossibleCorrespondenceReason.code = 'Payment Handling Acceptance';
            paymentHandlingAcceptancePossibleCorrespondenceReason.displayName = 'Payment Handling Acceptance';

            let policyPossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            policyPossibleCorrespondenceSubject.code = 'Policy';
            policyPossibleCorrespondenceSubject.displayName = 'Policy';
            policyPossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                changeRequestPossibleCorrespondenceReason,
                disputeOfPrivateFloodInsuranceRequestPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
                cancellationInquiryPossibleCorrespondenceReason,
                rewritePaymentPossibleCorrespondenceReason,
                nonRenewalPaymentPossibleCorrespondenceReason,
            ];

            let policyEndorsementPossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            policyEndorsementPossibleCorrespondenceSubject.code = 'Policy Endorsement';
            policyEndorsementPossibleCorrespondenceSubject.displayName = 'Policy Endorsement';
            policyEndorsementPossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                changeRequestPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
                cancellationInquiryPossibleCorrespondenceReason,
                rushRequestPossibleCorrespondenceReason,
            ];

            let newApplicationPossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            newApplicationPossibleCorrespondenceSubject.code = 'New Application';
            newApplicationPossibleCorrespondenceSubject.displayName = 'New Application';
            newApplicationPossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                changeRequestPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
                applicationInquiryPossibleCorrespondenceReason,
                rushRequestPossibleCorrespondenceReason,
            ];

            let claimManagementPossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            claimManagementPossibleCorrespondenceSubject.code = 'Claim Management';
            claimManagementPossibleCorrespondenceSubject.displayName = 'Claim Management';
            claimManagementPossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                requestToInitiateNewClaimPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
            ];

            let underwritingManagementPossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            underwritingManagementPossibleCorrespondenceSubject.code = 'Underwriting Management';
            underwritingManagementPossibleCorrespondenceSubject.displayName = 'Underwriting Management';
            underwritingManagementPossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
                underwritingInquiryPossibleCorrespondenceReason
            ];

            let producerManagementPossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            producerManagementPossibleCorrespondenceSubject.code = 'Producer Management';
            producerManagementPossibleCorrespondenceSubject.displayName = 'Producer Management';
            producerManagementPossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
            ];

            let financialTransactionsPossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            financialTransactionsPossibleCorrespondenceSubject.code = 'Financial Transactions';
            financialTransactionsPossibleCorrespondenceSubject.displayName = 'Financial Transactions';
            financialTransactionsPossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
                rejectedPaymentPossibleCorrespondenceReason
            ];

            let stateCompliancePossibleCorrespondenceSubject: PossibleCorrespondenceSubject = new PossibleCorrespondenceSubject();
            stateCompliancePossibleCorrespondenceSubject.code = 'State Compliance';
            stateCompliancePossibleCorrespondenceSubject.displayName = 'State Compliance';
            stateCompliancePossibleCorrespondenceSubject.correspondenceReasons = [
                formsAndDocumentsPossibleCorrespondenceReason,
                statusPossibleCorrespondenceReason,
                websiteNavigationPossibleCorrespondenceReason,
            ];

            setTimeout(() => {
                resolve([
                    policyPossibleCorrespondenceSubject,
                    policyEndorsementPossibleCorrespondenceSubject,
                    newApplicationPossibleCorrespondenceSubject,
                    claimManagementPossibleCorrespondenceSubject,
                    underwritingManagementPossibleCorrespondenceSubject,
                    producerManagementPossibleCorrespondenceSubject,
                    financialTransactionsPossibleCorrespondenceSubject,
                    stateCompliancePossibleCorrespondenceSubject,
                ]);
            }, 1000);
        });
    }
};